export default class Loader {

	/**
	* Loads a new page by loading :
	*   - Images
	* TODO: - Load the view on first load of the site, not just on page change
	*
	* @param {Node} view - The DOM Element which is the view you want to load
	*
	* @returns {Promise} - Resolved when all components are loaded
	*/
	static load(view) {
		return new Promise((resolve) => {
			const images = Loader.getImages(view)
			const promises = []

			if (images && images.length) promises.push(Loader.loadImages(images))

			Promise.all(promises)
			.then(resolve)
		})
	}

	static getImages(view) {
		const imgs = view.querySelectorAll('img')
		const images = []

		for (let i = 0; i < imgs.length; i++) {
			if (imgs[i].dataset.src) {
				images.push(imgs[i])
			}
		}

		return images
	}

  /**
    * Loads an array of images or string urls
    *
    * @param {Array} images - An array of Nodes `img` or String urls
    *
    * @returns {Promise} - Resolved when all images are loaded
    */
	static loadImages(images) {
		return new Promise((resolve) => {
			const promises = []

			for (let i = 0; i < images.length; i++) {
				promises.push(Loader.loadImage(images[i], images.length))
			}

			Promise.all(promises)
				.then(resolve)
		})
	}

  /**
    * Loads an image
    * TODO: - Check `data-src` instead of `src`
    *
    * @param {Node/String} image - The Node img of the image to load
    * @param {Node/Number} total - The number of images to load in total
    *
    * @returns {Promise} - Resolve when the image is loaded
    */
	static loadImage(image, total) {
		return new Promise((resolve) => {
			const src = image.dataset.src
			const img = new Image()

			img.onload = () => {
				image.removeAttribute('data-src')
				image.src = src
				image.classList.add('show')
				if (Loader.cb) Loader.cb(total)
				resolve()
			}

			img.src = src
		})
	}

	static setCallback(fn = () => { }) {
		Loader.cb = fn
	}
}



// WEBPACK FOOTER //
// ./scripts/util/Loader.js